<template>
  <div class="invite-friend">
    <img class="course-back" @click="closeInvite()" src="https://s6.bihukankan.com/h5static/course-image/course-back.png" alt="">
    <div class="invite-friend-title">长按图片保存，邀请好友参与</div>
    <DrawShare></DrawShare>
    <div class="tips align jus direction" @click="showExplain()">
      <icon type="wenben" size=".44rem"></icon>
      <div>说明</div>
    </div>
    <div class="invite-tips align between">
      <div class="invite-header">邀请可赚<span>¥{{$_.get(this.$store.state, 'courseInfo.options.income')}}</span>元</div>
      <div class="focus-wx-service" @click="showWxCode()">关注服务号提现</div>
    </div>
    <van-overlay :show="showExplainModal" @click="showExplainModal = false">
      <div class="course-link-toast-box">
        <icon type="guanbi1" size='.6rem' class="guanbi1" @click="showExplainModal = false"></icon>
        <div class="course-link-toast" @click.stop="()=>{}">
          <div class="course-link-toast-title">说明</div>        
          <div class="course-link-toast-detail">1.活动成功报名后，可生成一张报名邀请海报，好友扫码付费参加后，你将获得好友付费额的40%为佣金，后续壁虎看看视情况调整佣金比例。</div>        
          <div class="course-link-toast-detail">2.获得的佣金可在个人中心查看，并申请提现，我们尽快通过审核，由运营阿碧通过微信个人转账佣金。</div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showWxCodeModal" class="focus-wx-code">
      <div class="course-link-toast-box">
        <img class="course-back" @click="showWxCodeModal = false" src="https://s6.bihukankan.com/h5static/course-image/course-back.png" alt="">
        <div class="invite-friend-title">长按关注服务号，提现佣金</div>
        <img src="https://s6.bihukankan.com/h5static/course-image/course-qrcode_for_gh_9adb64f305f6_2581.png" alt="" class="wx-code-icon">
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import DrawShare from './DrawShare'
  export default {
    components: {
      DrawShare,
    },
    data() {
      return {
        showExplainModal: false,
        showWxCodeModal: false
      }
    },
    methods: {
      closeInvite() {
        this.$emit('update:inviteFriends', false)
      },
      showExplain() {
        this.showExplainModal = !this.showExplainModal
      },
      showWxCode() {
        this.showWxCodeModal = !this.showWxCodeModal
      }
    },
  }
</script>

<style lang="less" scoped>
  .invite-friend {
    background: #000;
    position: relative;
    min-height: 100vh;
    .course-back {
      position: absolute;
      left: .48rem;
      top: .48rem;
      width: 0.48rem;
      height: 0.48rem;
    }
    .invite-friend-title {
      font-size: .32rem;
      color: #ff5000;
      text-align: center;
      line-height: .6rem;
      padding: 0.1rem 0 0.3rem;
    }
    .tips {
      width: 1rem;
      height: 1rem;
      background: #69C0FF;
      border-radius: 100%;
      color: #fff;
      font-size: .24rem;
      position: fixed;
      right: .20rem;
      bottom: 1.4rem;
      z-index: 4;
      img {
        width: 0.48rem;
        height: 0.48rem;
      }
      div {
        margin-top: 0.05rem;
      }
    }
    .course-link-toast-box {
      position: relative;
      .guanbi1 {
        position: absolute;
        right: .75rem;
        top: -1.2rem;
      }
    }
    .course-link-toast {
      width: 6rem;
      height: 6.4rem;
      background: #40A9FF;
      margin: 2rem auto;
      color: #fff;
      padding: .6rem;
      border-radius: .16rem;
      padding-top: 1rem;
      position: relative;
      
      .course-link-toast-title {
        font-size: .6rem;
        text-align: center;
        font-weight: bold;
      }
      .course-link-toast-detail {
        margin-top: .28rem;
        font-size: .28rem;
        line-height: 0.44rem;
      }
    }
    .invite-tips {
      height: 0.96rem;
      background: #40A9FF;
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100vw;
      padding: 0 .32rem;
      font-size: .4rem;
      .invite-header {
        color: #fff;
        line-height: 0.96rem;
        span {
          color: #ff5000;
        }
      }
      .focus-wx-service {
        width: 3.12rem;
        height: 0.64rem;
        line-height: 0.64rem;
        border-radius: .32rem;
        text-align: center;
        background: #fff;
        color: #40A9FF;
      }
    }
    .focus-wx-code {
      position: fixed;
      z-index: 10;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: #000;
      .wx-code-icon {
        width: 5.16rem;
        height: 5.16rem;
        display: block;
        margin: 0.8rem auto;
      }
    }
  }
</style>